//NOTE: route file name was changed so these routes don't load
//because the epic was merged into dev to get a core lib change
//rename file back when ready for release
export default [
	{
		path: '/system/login',
		name: 'login',
		props: route => ({
			resultCode: route.query.resultCode
				? parseInt(route.query.resultCode)
				: null,
			userToken: route.query.tk,
			returnUrl: route.query.ReturnUrl || route.query.returnUrl || '/',
			loginEmail: route.query.email
		}),
		meta: {
			isPublic: true,
			notCompanyRoute: true,
			pageTitle: 'Login'
		},
		component: () =>
			import(
				/* webpackChunkName: "login" */ '@/sections/system/login/login-page.vue'
			)
	},
	{
		path: '/system/login/code/:sendType',
		name: 'login-code-entry',
		props: route => ({
			sendType: route.params.sendType || 'primaryemail',
			userToken: route.query.tk,
			returnUrl: route.query.ReturnUrl || route.query.returnUrl,
			loginEmail: route.query.email
		}),
		meta: {
			isPublic: true,
			notCompanyRoute: true,
			pageTitle: 'Enter Your Login Code'
		},
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "login" */ '@/sections/system/login/login-code-entry-page.vue'
			)
	},
	{
		path: '/system/login/resetpassword',
		name: 'reset-password',
		meta: {
			isPublic: true,
			notCompanyRoute: true,
			pageTitle: 'Reset Password'
		},
		props: route => ({
			verificationCode: route.query.vc,
			userId: route.query.uid,
			sentTo: route.query.to,
			returnUrl: route.query.ReturnUrl || route.query.returnUrl || '/'
		}),
		component: () =>
			import(
				/* webpackChunkName: "login" */ '@/sections/system/login/reset-password-page.vue'
			)
	},
	{
		//this is for local dev only
		//need to load this page into the request token iframe
		//for the login page to work
		path: '/account/requesttoken',
		name: 'request-token',
		meta: {
			isPublic: true,
			notCompanyRoute: true,
			pageTitle: 'Request Token'
		},
		component: () =>
			import(
				/* webpackChunkName: "login" */ '@/sections/system/login/request-token-page.vue'
			)
	}
];
